import { useTranslation } from 'react-i18next';
import { TooltipContainer } from './styled';

const IgnoreFallbackCompressorsTooltip = () => {
  const { t } = useTranslation();

  return (
    <TooltipContainer>
      <div className="tooltip-paragraph">{t('ignoreFallbackCompressorsTooltip')}</div>
      <div className="tooltip-bullet-list">
        <div className="tooltip-bullet-item">
          <span className="tooltip-bullet">•</span>
          {t('ignoreFallbackCompressorsTooltipBullet1')}
        </div>
        <div className="tooltip-bullet-item">
          <span className="tooltip-bullet">•</span>
          {t('ignoreFallbackCompressorsTooltipBullet2')}
        </div>
      </div>
      <div className="tooltip-paragraph">{t('ignoreFallbackCompressorsTooltipNote')}</div>
    </TooltipContainer>
  );
};

export default IgnoreFallbackCompressorsTooltip;
